var BreadCrumbItem = /** @class */ (function () {
    function BreadCrumbItem(
    /** Text to show in the breadcrumb component. */
    label, 
    /** URL to use when the breadcrumb is clicked. */
    link) {
        this.label = label;
        this.link = link;
    }
    return BreadCrumbItem;
}());
export { BreadCrumbItem };
